<template>
  <component
    class="default-title"
    :class="component_classes"
    v-html="title"
    :is="title_tag">
  </component>
</template>

<script>
export default {
  name: "DefaultTitle",
  props: {
    title: {
      type: String,
      default: '',
    },
    title_tag: {
      type: String,
      default: 'h3',
    },
    white: {
      type: Boolean,
      default: false,
    },
    smaller: {
      type: Boolean,
      default: false,
    },
    tiny: {
      type: Boolean,
      default: false,
    },
    upper_case: {
      type: Boolean,
      default: false,
    },
    pre_wrap: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    component_classes() {
      return {
        white: this.white,
        smaller: this.smaller,
        tiny: this.tiny,
        upper_case: this.upper_case,
        pre_wrap: this.pre_wrap,
      }
    }
  }
}
</script>
